
// 🐕 Knuffig Logo Hover - Wuff Wuff + fliegende Pfoten
document.addEventListener('DOMContentLoaded', function() {
    const logoLink = document.querySelector('.header__heading-link');
    if (!logoLink) return;
    
    // "Wuff Wuff!" Text hinten anfügen
    const barkSpan = document.createElement('span');
    barkSpan.className = 'knuffig-bark';
    barkSpan.textContent = '🐕 Wuff Wuff!';
    logoLink.appendChild(barkSpan);
    
    // Cursor auf Pfote ändern
    const logoImg = logoLink.querySelector('img');
    if (logoImg) {
        logoImg.style.cursor = "url('data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'32\' height=\'32\'><text y=\'22\' font-size=\'22\'>🐾</text></svg>'), auto";
    }
    
    // Fliegende Pfoten beim Hover
    let hoverTimer = null;
    logoLink.addEventListener('mouseenter', function(e) {
        // Mehrere Bark Varianten
        const barks = ['🐕 Wuff Wuff!', '🐕 Wuff!', '🐶 Bell!', '🐕 Wuff Wuff! 🦴', '🐾 Hallo!'];
        barkSpan.textContent = barks[Math.floor(Math.random() * barks.length)];
        
        // Fliegende Pfoten spawnen
        hoverTimer = setInterval(function() {
            const paw = document.createElement('span');
            paw.className = 'knuffig-paw';
            paw.textContent = '🐾';
            paw.style.left = (10 + Math.random() * 60) + 'px';
            paw.style.top = (10 + Math.random() * 30) + 'px';
            paw.style.setProperty('--paw-x', (50 - Math.random() * 100) + 'px');
            paw.style.setProperty('--paw-y', (-30 - Math.random() * 50) + 'px');
            paw.style.fontSize = (14 + Math.random() * 10) + 'px';
            logoLink.appendChild(paw);
            setTimeout(() => paw.remove(), 1000);
        }, 400);
    });
    
    logoLink.addEventListener('mouseleave', function() {
        barkSpan.textContent = '🐕 Wuff Wuff!'; // Reset
        if (hoverTimer) {
            clearInterval(hoverTimer);
            hoverTimer = null;
        }
    });
});




// ===== UPDATED: MegaMenu Hover - ALLE Produkte + KHALISIA + Knuffig Kids =====
// Volles Produktbild-Mapping
const KnuffigAllProductImages = {
    // === KNUFFIG KIDS ===
    'Lenkertaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
    'Kindergarten Rucksäcke': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Dino-Grau_Knuffiger_Kinderrucksack_Dinosaurier_Kinder-Rucksack_400x.webp?v=1776697188',
    'Toniebox Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/transporttasche-dinosaurier-grau-toniebox-abenteuer_400x.jpg?v=1776697188',
    'Kindergarten Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/kinder-umhaengetasche-dinosaurier-gruen-toniebox-rucksack_400x.jpg?v=1776697188',
    'Laufrad Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-laufrad-einhorn-tuerkis-2_400x.webp?v=1776697188',
    
    // === KHALISIA ===
    'Fahrrad Einkaufstaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-fahrradtasche-gepaecktraeger-gelb-wasserdicht-reflektoren_400x.jpg?v=1776699486',
    'Kühltaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia_Kuehltasche_400x.png?v=1776699318',
    'Wasserdichte Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-fahrrad-einkaufstasche-gepaecktraeger-22L-Thermo-Shopper_400x.jpg?v=1776699486',
    'Thermo Shopper': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
    'Roll-Up Shopper': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia-Fahrradtaschen-Gepaektraeger-Tasche-22L-Shopper_400x.jpg?v=1776697188',
    'Fahrrad Kühltaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia_Kuehltasche_400x.png?v=1776699318',
    'Wasserdichte Fahrradtaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/KHALISIA-SpeedBag-Blau-21_400x.jpg?v=1776697188',
    
    // === TOP-LEVEL ===
    'Alle Produkte': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
    'Knuffig Kids': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
    'KHALISIA': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
};

// Bessere Bild-Hover-Funktion
function initMegaMenuHover() {
    const megamenus = document.querySelectorAll('.mega-menu, .mega-menu__list, .mega-menu__item');
    
    megamenus.forEach(menu => {
        // Hover-Container pro Menü
        let hoverBox = menu.querySelector('.kk-hover-box');
        if (!hoverBox) {
            hoverBox = document.createElement('div');
            hoverBox.className = 'kk-hover-box';
            hoverBox.innerHTML = '<div class="kk-hover-inner"><img class="kk-hover-img" alt="Produkt"><span class="kk-hover-label"></span></div>';
            menu.appendChild(hoverBox);
        }
        
        // ALLE Links im Megamenü tracken
        const links = menu.querySelectorAll('a');
        links.forEach(link => {
            link.addEventListener('mouseenter', function(e) {
                const text = this.textContent.trim();
                const imgUrl = KnuffigAllProductImages[text];
                
                if (imgUrl) {
                    const img = hoverBox.querySelector('.kk-hover-img');
                    const label = hoverBox.querySelector('.kk-hover-label');
                    img.src = imgUrl;
                    label.textContent = text;
                    hoverBox.classList.add('kk-hover-show');
                    hoverBox.style.display = 'flex';
                    
                    // Position relativ zum Link
                    const rect = this.getBoundingClientRect();
                    const menuRect = menu.getBoundingClientRect();
                    hoverBox.style.position = 'fixed';
                    hoverBox.style.top = (rect.top - 10) + 'px';
                    hoverBox.style.left = (rect.right + 10) + 'px';
                }
            });
            
            link.addEventListener('mouseleave', function() {
                setTimeout(() => {
                    if (!hoverBox.matches(':hover')) {
                        hoverBox.classList.remove('kk-hover-show');
                    }
                }, 300);
            });
        });
        
        // Bleiben auf dem Hover-Box erlaubt
        hoverBox.addEventListener('mouseenter', () => {
            hoverBox.classList.add('kk-hover-show');
        });
        hoverBox.addEventListener('mouseleave', () => {
            hoverBox.classList.remove('kk-hover-show');
        });
    });
}

// Zusätzlich: Alle Navigation-Links in der Desktop-Navigation tracken
function initNavHover() {
    // Navigations-Liste finden: Desktop-Navi
    const navLists = document.querySelectorAll('.list-menu, .list-menu--inline > li');
    
    navLists.forEach(li => {
        // Nur Top-Level List-Items
        if (li.tagName === 'LI' || li.closest('.mega-menu')) return;
        
        const link = li.querySelector('a');
        if (!link) return;
        
        // Hover-Container
        let hoverBox = li.querySelector('.kk-hover-box');
        if (hoverBox) return; // schon da
        
        hoverBox = document.createElement('div');
        hoverBox.className = 'kk-hover-box';
        hoverBox.innerHTML = '<div class="kk-hover-inner"><img class="kk-hover-img" alt="Produkt"><span class="kk-hover-label"></span></div>';
        li.style.position = 'relative';
        li.appendChild(hoverBox);
        
        link.addEventListener('mouseenter', function() {
            const text = this.textContent.trim();
            const imgUrl = KnuffigAllProductImages[text];
            if (imgUrl) {
                const img = hoverBox.querySelector('.kk-hover-img');
                const label = hoverBox.querySelector('.kk-hover-label');
                img.src = imgUrl;
                label.textContent = text;
                hoverBox.classList.add('kk-hover-show');
            }
        });
        link.addEventListener('mouseleave', function() {
            setTimeout(() => {
                if (!hoverBox.matches(':hover')) {
                    hoverBox.classList.remove('kk-hover-show');
                }
            }, 300);
        });
    });
}

// Beides ausführen
document.addEventListener('DOMContentLoaded', function() {
    initMegaMenuHover();
    initNavHover();
});


// ===== 🖼️ MegaMenu Hover IMAGE - Bleibt solange Maus drauf =====
function initProductHover() {
    // Hover-Container erstellen (einmal global)
    let hbox = document.getElementById('kk-product-hover');
    if (!hbox) {
        hbox = document.createElement('div');
        hbox.id = 'kk-product-hover';
        hbox.className = 'kk-product-hover';
        hbox.innerHTML = '<div class="kk-ph-inner"><img class="kk-ph-img" alt="Produktvorschau"><span class="kk-ph-label"></span></div>';
        document.body.appendChild(hbox);
    }
    
    // Maus-Tracking
    let hideTimer = null;
    
    function showProductImage(text, linkEl) {
        const imgMap = {
            'Lenkertaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
            'Kindergarten Rucksäcke': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Dino-Grau_Knuffiger_Kinderrucksack_Dinosaurier_Kinder-Rucksack_400x.webp?v=1776697188',
            'Toniebox Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/transporttasche-dinosaurier-grau-toniebox-abenteuer_400x.jpg?v=1776697188',
            'Kindergarten Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/kinder-umhaengetasche-dinosaurier-gruen-toniebox-rucksack_400x.jpg?v=1776697188',
            'Laufrad Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-laufrad-einhorn-tuerkis-2_400x.webp?v=1776697188',
            'Fahrrad Einkaufstaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-fahrrad-einkaufstasche-gepaecktraeger-22L-Thermo-Shopper_400x.jpg?v=1776699486',
            'Kühltaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia_Kuehltasche_400x.png?v=1776699318',
            'Wasserdichte Taschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/KHALISIA-SpeedBag-Blau-21_400x.jpg?v=1776697188',
            'Thermo Shopper': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
            'Roll-Up Shopper': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia-Fahrradtaschen-Gepaektraeger-Tasche-22L-Shopper_400x.jpg?v=1776697188',
            'Fahrrad Kühltaschen': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia_Kuehltasche_400x.png?v=1776699318',
            'Alle Produkte': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
            'Knuffig Kids': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
            'KHALISIA': 'https://cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
        };
        
        const url = imgMap[text];
        if (!url) return false;
        
        clearTimeout(hideTimer);
        const img = hbox.querySelector('.kk-ph-img');
        const label = hbox.querySelector('.kk-ph-label');
        img.src = url;
        label.textContent = text;
        
        // Position rechts vom Link
        const rect = linkEl.getBoundingClientRect();
        hbox.style.left = (rect.right + 15) + 'px';
        hbox.style.top = Math.max(10, rect.top + (rect.height / 2) - 90) + 'px';
        hbox.style.display = 'flex';
        hbox.classList.add('active');
        return true;
    }
    
    function hideProductImage() {
        hideTimer = setTimeout(() => {
            hbox.style.display = 'none';
            hbox.classList.remove('active');
        }, 100);
    }
    
    // ALLE Navigation-Links
    document.querySelectorAll('.mega-menu a, .list-menu a, .header__inline-menu a').forEach(link => {
        link.addEventListener('mouseenter', function(e) {
            const text = this.textContent.trim();
            showProductImage(text, this);
        });
        link.addEventListener('mouseleave', hideProductImage);
    });
    
    // Auf Hover-Box bleiben erlaubt
    hbox.addEventListener('mouseenter', () => {
        clearTimeout(hideTimer);
        hbox.classList.add('active');
        hbox.style.display = 'flex';
    });
    hbox.addEventListener('mouseleave', hideProductImage);
    
    // Bei Scroll ausblenden
    document.addEventListener('scroll', hideProductImage);
}

document.addEventListener('DOMContentLoaded', initProductHover);

document.addEventListener('DOMContentLoaded', function() {
    let hbox = document.getElementById('kk-product-hover');
    if (!hbox) {
        hbox = document.createElement('div');
        hbox.id = 'kk-product-hover';
        hbox.className = 'kk-product-hover';
        hbox.innerHTML = '<div><img class="kk-ph-img" alt="Produktvorschau"><span class="kk-ph-label"></span></div>';
        document.body.appendChild(hbox);
    }
    
    const imgMap = {
        'Lenkertaschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
        'Kindergarten Rucksäcke': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/Dino-Grau_Knuffiger_Kinderrucksack_Dinosaurier_Kinder-Rucksack_400x.webp?v=1776697188',
        'Toniebox Taschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/transporttasche-dinosaurier-grau-toniebox-abenteuer_400x.jpg?v=1776697188',
        'Kindergarten Taschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/kinder-umhaengetasche-dinosaurier-gruen-toniebox-rucksack_400x.jpg?v=1776697188',
        'Laufrad Taschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-laufrad-einhorn-tuerkis-2_400x.webp?v=1776697188',
        'Fahrrad Einkaufstaschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-fahrrad-einkaufstasche-gepaecktraeger-22L-Thermo-Shopper_400x.jpg?v=1776699486',
        'Kühltaschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia_Kuehltasche_400x.png?v=1776699318',
        'Wasserdichte Taschen': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/KHALISIA-SpeedBag-Blau-21_400x.jpg?v=1776697188',
        'Thermo Shopper': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
        'Roll-Up Shopper': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/Khalisia-Fahrradtaschen-Gepaektraeger-Tasche-22L-Shopper_400x.jpg?v=1776697188',
        'Knuffig Kids': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
        'Alle Produkte': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/knuffig-lenkertasche-kinder-beige-3_400x.webp?v=1776697188',
        'KHALISIA': '//cdn.shopify.com/s/files/1/0791/8721/4680/files/khalisia-thermo-shopper-kuehltasche-lebensmittel-vegan-nachhaltig_400x.jpg?v=1776699365',
    };
    
    let timer = null;
    
    function showImg(text, el) {
        const url = imgMap[text];
        if (!url) return;
        clearTimeout(timer);
        const rect = el.getBoundingClientRect();
        hbox.querySelector('.kk-ph-img').src = url;
        hbox.querySelector('.kk-ph-label').textContent = text;
        hbox.style.left = (rect.right + 15) + 'px';
        hbox.style.top = Math.max(10, rect.top + rect.height/2 - 90) + 'px';
        hbox.style.display = 'flex';
        hbox.classList.add('active');
    }
    function hideImg() {
        timer = setTimeout(() => { hbox.style.display = 'none'; hbox.classList.remove('active'); }, 100);
    }
    
    document.querySelectorAll('.mega-menu a, .list-menu a, .header__inline-menu a, nav a, .menu-drawer a').forEach(a => {
        if (a.closest('.header__icons')) return;
        a.addEventListener('mouseenter', function() { showImg(this.textContent.trim(), this); });
        a.addEventListener('mouseleave', hideImg);
    });
    
    hbox.addEventListener('mouseenter', () => { clearTimeout(timer); hbox.style.display = 'flex'; });
    hbox.addEventListener('mouseleave', hideImg);
    
    // Wuff Sound bei Logo Hover
    const logos = document.querySelectorAll('[alt*="Knuffig"], [src*="Knuffig"]');
    logos.forEach(logo => {
        logo.addEventListener('mouseenter', function() {
            try {
                const ctx = new (window.AudioContext || window.webkitAudioContext)();
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                osc.type = 'sine';
                osc.frequency.setValueAtTime(400, ctx.currentTime);
                osc.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.1);
                gain.gain.setValueAtTime(0.15, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.2);
                osc.connect(gain);
                gain.connect(ctx.destination);
                osc.start();
                osc.stop(ctx.currentTime + 0.2);
            } catch(e) {}
        });
    });
});
